import ContactInformationContainer from './ContactInformationContainer';

export default ContactInformationContainer;